module.exports = __webpack_public_path__ + "static/verdaccio-3c8975475d782107d2f1d60c986024f0.svg";